export const MOBILE_SIZE = {
    width: 900,
};
export default MOBILE_SIZE;